/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Use_SoundboardInputs */



/**
* | output |
* | --- |
* | "Use Soundboard" |
*
* @param {Leveling_Perm_Use_SoundboardInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_use_soundboard = /** @type {((inputs?: Leveling_Perm_Use_SoundboardInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Use_SoundboardInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Использовать звуковую панель")
	return /** @type {LocalizedString} */ ("Use Soundboard")
});